import React from 'react';
import { Typography, Button, Empty } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';

interface Props {
  salonPhone?: string;
}

class EmptyState extends React.PureComponent<Props> {
  render() {
    const { salonPhone } = this.props;
    return (
      <Empty description={false} style={{ marginTop: 64 }}>
        <Typography.Title level={4}>Booking is not available now</Typography.Title>

        {salonPhone && (
          <>
            <div style={{ marginTop: 30 }}>Please call us. Sorry for the inconvenience!</div>
            <div style={{ marginTop: 20, paddingLeft: 20, paddingRight: 20 }}>
              <a rel="nofollow" href={`tel:${salonPhone}`}>
                <Button size="large" type="primary">
                  <PhoneOutlined rotate={90} /> {salonPhone}
                </Button>
              </a>
            </div>
          </>
        )}
      </Empty>
    );
  }
};

export default EmptyState;
